import type { StartAppListening } from '@/store/listenerMiddleware.ts';
import { registerOpenBlotterListenerForOptions } from '@/store/option/listeners/blotter-open-trade-capture-listener.ts';
import { registerChangeClientListenerForOption } from '@/store/option/listeners/change-client-listener.ts';
import { registerDuplicateOptionTradeCaptureListener } from '@/store/option/listeners/duplicate-option-trade-capture-listeners.ts';
import { registerRfsOptionListeners } from '@/store/option/listeners/rfs-listeners.ts';

export function registerOptionListeners(startAppListening: StartAppListening): void {
  registerChangeClientListenerForOption(startAppListening);
  registerRfsOptionListeners(startAppListening);
  registerDuplicateOptionTradeCaptureListener(startAppListening);
  registerOpenBlotterListenerForOptions(startAppListening);
}
